// extracted by mini-css-extract-plugin
export default {"root":"CApwqsLuOg1zIlPrPslA","wrap":"PxnuXcH13GdrUXpLcAag","main":"VjymdUYcNBIEQM6T47Zm","header":"fVQjH7zCSRae4hlg6zN0","row":"xh3uFDjfo0xIAQfRy7JF"};